import { useEffect, useRef, useState } from 'react';
import Loader from './Loader';

export default function OfflineReloadBlocker() {
  const [showLoader, setShowLoader] = useState(false);
  const lastReloadRef = useRef(0);

  useEffect(() => {
    const handleOffline = () => {
      const now = Date.now();
      if (now - lastReloadRef.current > 30000) {
        lastReloadRef.current = now;
        setShowLoader(true);
      }
    };

    window.addEventListener('offline', handleOffline);
    return () => window.removeEventListener('offline', handleOffline);
  }, []);

  if (!showLoader) return null;

  return (
    <div className="fixed inset-0 z-[9999]">
      <Loader />
    </div>
  );
}
